const _ = require('lodash');
const mapping = require('arbitrip-common/theme/mapping');
const DEFAULT_THEME_CONFIG_NAME = 'default'; // default arbitrip config file

const CONFIGS = {
    HitechZone: () => import('arbitrip-common/theme/footer/configs/HitechZone.json'),
    LetStay: () => import('arbitrip-common/theme/footer/configs/LetStay.json'),
    Elal: () => import('arbitrip-common/theme/footer/configs/Elal.json'),
    Isracard: () => import('arbitrip-common/theme/footer/configs/Isracard.json'),
    AirHaifa: () => import('arbitrip-common/theme/footer/configs/AirHaifa.json'),
    default: () => import('arbitrip-common/theme/footer/configs/default.json'),
};

export const loadFooterConfig = async (company_id) => {
    const company_theme_name = _.get(mapping, company_id, DEFAULT_THEME_CONFIG_NAME);

    let configModule;
    try {
        const importFn = CONFIGS[company_theme_name] || CONFIGS[DEFAULT_THEME_CONFIG_NAME];
        configModule = await importFn();
    } catch (error) {
        console.error('Error loading footer configuration:', error);
        configModule = await CONFIGS[DEFAULT_THEME_CONFIG_NAME]();
    }

    const loadedConfig = configModule.default;

    return loadedConfig;
};
